import clsx from 'clsx'
import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import styles from './main-layout.module.scss'
import { RouteEnum } from '../../constants/routes.enum'
import { MainHeader } from '../../modules/main/header/main.header'
import { MainSidebar } from '../../modules/main/sidebar/main.sidebar'

export const MainLayoutNoPadding: React.FC = () => {
  const location = useLocation()

  const hasProgress = location.pathname === `/${RouteEnum.ONBOARDING}`

  return (
    <div className={clsx(styles.mainLayout, 'd-flex h-100')}>
      <MainSidebar />
      <div className={clsx(styles.mainLayoutContent, 'h-100')}>
        <MainHeader hasProgress={hasProgress} />
        <div className={clsx(styles.mainLayoutWrapper, styles.mainLayoutWrapperNoPadding)}>
          <Outlet />
        </div>
      </div>
    </div>
  )
}
